import axios from "axios";
import { message } from "ant-design-vue";

/**
 * 创建axios对象
 * @type {AxiosInstance}
 */
const jaxios = axios.create();
/**
 * 设置超时时间，单位毫秒(20秒)
 * @type {number}
 */
jaxios.defaults.timeout = 1000 * 50;

jaxios.defaults.headers.post["Content-Type"] = "application/json";

// 后台服务器接口地址， Webpack自带NODE_ENV，不用任何env文件
if (process.env.NODE_ENV === "development") {
  jaxios.defaults.baseURL = "http://127.0.0.1:8787";
} else {
  jaxios.defaults.baseURL = "https://open.7milk.com";
}

/**
 * 请求拦截器
 */
jaxios.interceptors.request.use(
  (config) => {
    if (localStorage.getItem("token") != null) {
      // Bearer
      config.headers.authorization = "Bearer " + localStorage.getItem("token");
    }
    return config;
  },
  (error) => {
    Promise.error(error);
  }
);

/**
 * 响应拦截器
 */

jaxios.interceptors.response.use(
  (response) => {
    if (response.status === 200) {
      return Promise.resolve(response);
    }
    return Promise.reject(response);
  },
  (error) => {
    /**
     * Promise.reject是Promise对象原型上的一个静态方法, 用于返回一个被拒绝的Promise对象,
     * reason参数是一个用于描述Promise对象被拒绝原因的值，可以是任何类型的值
     */
    //return Promise.reject(error.response);
    if (error.request.status) {
      switch (error.request.status) {
        case 401:
          message.error("*未登入，非法操作!");
          break;
        case 403:
          message.error("*登录过期，请重新登录!");
          // 清除token
          localStorage.removeItem("token");
          break;
        case 404:
          message.info("*请求不存在!");
          break;
        default:
          message.warning("*系统异常!");
          break;
      }
    }
  }
);

export default jaxios;
